import { render, staticRenderFns } from "./Acc.vue?vue&type=template&id=5a51637d&"
import script from "./Acc.vue?vue&type=script&lang=js&"
export * from "./Acc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports